import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import loadingReducer from './common/loadingModule';
import userReducer, { userSaga } from './su/userModule';
import userCartReducer, { userCartSaga } from './su/userCartModule';
import userCheckReducer, { userCheckSaga } from './su/userCheckModule';
import userInfoReducer, { userInfoSaga } from './su/userInfoModule';
import esItemsReducer, { esItemsSaga } from './es/esItemModule';
import cateItemsReducer, { cateItemsSaga } from './common/cateModule';
import brandItemsReducer, { brandItemsSaga } from './common/brandModule';
import prodItemsReducer, { elkCateInfoItemsSaga } from './common/prodModule';
import prodDetailReducer, { userDetailSaga } from './pd/prodDetailModule';
import esApplyReducer, { esApplyItemsSaga } from './es/esApplyModule';
import stFilterReducer, { stFilterSaga } from './st/stFilterModule';
import stContentsReducer, { stContentsSaga } from './st/stContentsModule';
import headerReducer from './common/headerModule';
import userBrandReducer, { userBrandSaga } from './su/userBrandModule';
import customserviceReducer, { customserviceSaga } from './cs/customserviceModule';
import searchReducer, { searchSaga } from './search/searchModule';
import mainReducer, { mainContentsSaga } from './hp/mainModule';
import esOrderReducer, { esOrderSaga } from './od/orderModule';
import userProdReducer, { userProdSaga } from './su/userProdModule';
import userSpaceReducer, { userSpaceSaga } from './su/userSpaceModule';
import campaignReducer, {campaignSaga} from './campaign/campaignModule'
import esMyReducer, { esMyItemsSaga } from './es/esMyModule';

/**
 * Store 로 저장될 Reducer 값
 */
const rootReducer = combineReducers({
    loadingReducer,
    userReducer,
    esItemsReducer,
    cateItemsReducer,
    brandItemsReducer,
    prodItemsReducer,
    esApplyReducer,
    headerReducer,
    userCartReducer,
    stFilterReducer,
    userCheckReducer,
    prodDetailReducer,
    userInfoReducer,
    userBrandReducer,
    customserviceReducer,
    stContentsReducer,
    searchReducer,
    mainReducer,
    esOrderReducer,
    userProdReducer,
    userSpaceReducer,
    campaignReducer,
    esMyReducer
});

export function* rootSaga() {
    yield all([userSaga(), esItemsSaga(),
    cateItemsSaga(), brandItemsSaga(),
    elkCateInfoItemsSaga(),
    esApplyItemsSaga(), stFilterSaga(),
    userCheckSaga(),
    userDetailSaga(),
    userInfoSaga(),
    userBrandSaga(),
    customserviceSaga(),
    stContentsSaga(), mainContentsSaga(), userCartSaga(),
    searchSaga(), esOrderSaga(), userProdSaga(), userSpaceSaga(), campaignSaga(), esMyItemsSaga()]);
}

export default rootReducer;
